//结构统一管理
import requests from "./resquest"
//method 有get 和 post两种方式
// 有参数的需要些模板字符串``
// export const reqGetSomeInfo = (p)=>requests({url:`"/baidu/${p}"`,method:"get"});
// // 无参数直接写
// export const reqGetSomeInfo2 = ()=>requests({url:"/baidu",method:"get"});
// //需要传对象的可以用data属性
// export const reqGetSomeInfo3 = (p,data)=>requests({url:`"/baidu"/${p}`,data:data,method:"get"});

export const getlistRecently=(params)=>{
    return requests({
        url:"/ky/KM/kmDoc/listRecently",
        method:"get",
        params
    })
}  
export const getlistDraft=(params)=>{
    return requests({
        url:"/ky/KM/kmDoc/new/listDraft",
        method:"get",
        params
    })
}  
export const getloadTreeData=(params)=>{
    return requests({
        url:"/ky/sys/category/loadTreeRoot",
        method:"get",
        params
    })
}  
export const searchDoc=(params)=>{
    return requests({
        url:"/ky/KM/kmDoc/new/searchDoc",
        method:"get",
        params
    })
}
export const getDictItemList=(params)=>{
    return requests({
        url:"/ky/sys/dictItem/list",
        method:"get",
        params
    })
}
export const getkmKnowledgeMap=(params)=>{
    return requests({
        url:"/ky/km/kmKnowledgeMap/notoken/list",
        method:"get",
        params
    })
}

export function downFile(url, params) {
    return requests({
        url:url,
        method:"get",
        params,
        responseType: 'blob',
    })
  }
// 自定义下载文件方法
export const downloadFileName=(url, parameter,$message)=> {
    return downFile(url, parameter).then((response) => {
      var fileName;
      // 前提是服务端要在header设置Access-Control-Expose-Headers: Content-Disposition
   // 前端才能正常获取到Content-Disposition内容
      var temp = response.headers['content-disposition']
      var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
      var matches = filenameRegex.exec(temp)
      if (matches != null && matches[1]) {
        let filename1 = matches[1].replace(/['"]/g, '')
        filename1 =filename1.replace(/\+/g,"%20")
        fileName=decodeURIComponent(filename1)
      }
      if (!response.data || response.data.size === 0) {
        // Vue.prototype['$message'].warning('文件下载失败')

        $message.error('文件下载失败！');
        return
      }
      if (typeof window.navigator.msSaveBlob !== 'undefined') {
        window.navigator.msSaveBlob(new Blob([response.data]), fileName)
      } else {
  
        let url = window.URL.createObjectURL(new Blob([response.data]))
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link) //下载完成移除元素
        window.URL.revokeObjectURL(url) //释放掉blob对象
        // Vue.prototype['$message'].success('文件已经下载')
        console.log('文件已经下载')
        $message({
            message: '文件下载成功！',
            type: 'success'
          });
      }
    })
  }
export default{
    getlistRecently,
    getlistDraft,
    getloadTreeData,
    searchDoc,
    getDictItemList,
    getkmKnowledgeMap,
    downloadFileName,
}